export default {
  white: '#fff',
  lighter: '#eee',
  light: '#ddd',
  regular: '#999',
  dark: '#666',
  darker: '#333',
  black: '#000',

  primary: '#22cc99',
  secundary: '#1f1e29',
  background: '#14131a',

  info: '#2299ff',
  success: '#23ad4d',
  error: '#dd5555',
  warning: '#bbcc11',

  transparent: 'transparent',
  blackTransparent: 'rgba(0,0,0,0.6)',
  whiteTransparent: 'rgba(255,255,255, 0.3)',
  header: '#1c1427',
};
